
import ReactECharts from "echarts-for-react";
import { useTranslation } from 'react-i18next';
import {isoTimeToLocalString} from "../pages/Trends/trendUtil";
import {transpose} from "underscore";


export default function BarChart(props) {

    const { data, timeAggType, timestamps, name, localTimeZone } = props;
    const { t } = useTranslation();

    const dimensions = ["timestamp"]
    data.forEach((item, i) => {
        dimensions.push(i.toString())
    });

    const matrix = [["timestamp", ...timestamps]];
    data.forEach((item, i) => {
        matrix.push([i.toString(), ...item.values])
    });

    const source = transpose(matrix);

    let series = [];

    data.forEach((trend, i) => {

        const curve = trend.metadata;

        const title = name ?? curve.name;

        let s = {
            name: title,
            type: 'bar',
            encode: {
                x: 'timestamp',
                y: i.toString()
            }
        }

        series.push(s)

    })

    let options = {
        dataset: {
            source: source,
            dimensions: dimensions,
        },
        xAxis: {
            type: 'time'
        },
        yAxis: {
        },
        grid: {
            left: '5%',
            right: '5%',
            top: 5,
            bottom: 45
        },
        tooltip: {
            trigger: "axis",
            confine: true,
            valueFormatter: (value) =>
                typeof value == "number" ? value.toLocaleString(navigator.language, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) : value
            ,
            axisPointer: {
                label: {
                    formatter: (params) => isoTimeToLocalString(params.value, timeAggType, localTimeZone)
                }
            }
        },
        series,
        textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif"
        },
    }
    if (series.length > 1) {
        options.legend = {
            show: true,
            bottom: 0,
        }
    }


    return (
        <ReactECharts option={options} />
    )
}
